export interface Role extends Record<string, any> {
  id: string;
  name: string;
  descriptiveId: string;
  description: string;
}
